module.exports = __webpack_public_path__ + "img/drh5_img.a57349de.png";